import React from "react";
import styles from "./BenefitIllustration.module.css";
import EnforcedLineChartTrad from "./EnforcedBarChartTrad";
import { amountFormat } from "../../utils";
import moment from "moment";
import { Formik } from "formik";
import PremiumTermSlider from "./sub/PremiumTermSlider";

export default function TradComponents({ data, formik, onInputChange }) {
  return (
    <div className="d-flex flex flex-column gap-5">
      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}> Your Policy Summary</span>
          <span className={styles["sub-heading-icon"]}>02</span>
        </div>
        <div>
          <ul>
            <li>
              You choose - <strong>{data?.policy?.product?.productName}</strong>
            </li>
            <li>
              Your policy is currently in{" "}
              <span style={{ color: "red", fontWeight: "bold" }}>
                Reduced Paid Up Status
              </span>
            </li>
            <li>
              As per your plan you need to pay{" "}
              <strong>{data?.policy?.premiumPaymentTerm}</strong> Premiums
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}> Your Policy Status</span>
          <span className={styles["sub-heading-icon"]}>03</span>
        </div>
        <div>
          <ul>
            <li>
              You paid only{" "}
              <strong>{data?.tradCurrentData?.premiumPaidTerm}</strong> premiums
              of amount{" "}
              <strong>
                Rs. {amountFormat(data?.policyPullData?.annualPremiumPaid)}
              </strong>{" "}
              till now
            </li>
            <li>
              Surrender value as on {moment().format("DD/MM/YYYY")} ={" "}
              <span style={{ color: "red", fontWeight: "bold" }}>
                Rs. {amountFormat(formik?.values?.currentFundValue)}{" "}
              </span>
              <i
                class="fa fa-arrow-down"
                style={{ fontSize: "18px", color: "red" }}
              ></i>
              <span style={{ color: "red", fontWeight: "bold" }}>
                {" "}
                {(
                  ((formik.values.currentFundValue -
                    data?.policy?.annualPremiumPaid) /
                    data?.policy?.annualPremiumPaid) *
                  100
                ).toFixed(2)}
                %
              </span>
            </li>
            <li>
              Your <strong>coverage has reduced</strong> from{" "}
              <strong>Rs.{amountFormat(data?.policy?.sumAssured)}</strong> to{" "}
              <span style={{ color: "red", fontWeight: "bold" }}>
                Rs.{amountFormat(data?.tradCurrentData?.sumAssured)}
              </span>
              , because your future premiums have been overdue since{" "}
              {moment(data?.policy?.premiumDueDate).format("DD/MM/YYYY")}
            </li>
          </ul>
        </div>
      </div>{" "}
      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}>
            {" "}
            Please select the number of premiums you want to pay
          </span>
          <span className={styles["sub-heading-icon"]}>04</span>
        </div>
        <div>
          <PremiumTermSlider
            totalTerm={data?.policy?.premiumPaymentTerm}
            alreadyPaidTerm={data?.tradCurrentData?.premiumPaidTerm}
            value={formik.agreeToPayTerm}
            onInputChange={onInputChange}
            fieldName="agreeToPayTerm"
          />

          {/* <PremiumTermSlider 
      totalTerm={10} 
      alreadyPaidTerm={1.98} 
      fieldName="agreeToPayTerm"
    /> */}

          {/* {data && (
            <EnforcedLineChartTrad
              data={data}
              roi={formik?.values?.returnCalculation}
            />
          )} */}
        </div>
      </div>
      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}>
            {" "}
            Projected Fund Growth if you{" "}
            {data?.tradData?.agreeToPayTerm===0
              ? "don't pay your future premium"
              : "continue to pay " + data?.tradData?.agreeToPayTerm +" premium"}
          </span>
          <span className={styles["sub-heading-icon"]}>05</span>
        </div>
        <div>
          {data && (
            <EnforcedLineChartTrad
              data={data}
              roi={formik?.values?.returnCalculation}
            />
          )}
        </div>
      </div>
      <div className="bg-white py-4 rounded border px-5 flex d-flex flex-column gap-3">
        <div className="flex d-flex justify-content-between align-items-center gap-3">
          <span className={styles["sub-heading"]}>
            {" "}
            Your Additional Policy Benefits
          </span>
          <span className={styles["sub-heading-icon"]}>06</span>
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-4 mb-3 d-flex">
              <div
                className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
              >
                Death Benefit ₹{amountFormat(data?.policy?.sumAssured)}
              </div>
            </div>
            <div className="col-12 col-lg-4 mb-3 d-flex">
              <div
                className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
              >
                Yearly Benefit Start from{" "}
                {data?.returnCalculation[0]?.policyYear}th Year
              </div>
            </div>
            <div className="col-12 col-lg-4 mb-3 d-flex">
              <div
                className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
              >
                Maturity Benefit At{" "}
                {
                  data?.returnCalculation[data?.returnCalculation?.length - 1]
                    ?.policyYear
                }
                th Year
              </div>
            </div>
            <div className="col-12 col-lg-4 mb-3 d-flex">
              <div
                className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
              >
                Tax Benefits U/S 80C & 10(10D)
              </div>
            </div>
            <div className="col-12 col-lg-4 mb-3 d-flex">
              <div
                className={`${styles["sub-gradient-card"]} p-4 h-100 d-flex flex-column justify-content-center w-100`}
              >
                Money Back Policy
              </div>
            </div>
          </div>
        </div>
        <strong>
          *The proceeds will be completely tax-free or taxed as LTCG.
        </strong>
      </div>
    </div>
  );
}
